var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var FreeReturnSvg = /* @__PURE__ */ __name(function FreeReturnSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M24.338 25.133v-1.689c0.041 0.001 0.089 0.002 0.138 0.002 2.359 0 4.271-1.912 4.271-4.271s-1.912-4.271-4.271-4.271c-0.048 0-0.097 0.001-0.145 0.002l0.007-0h-20.516v-1.689h20.516c0.048-0.001 0.105-0.002 0.163-0.002 3.292 0 5.96 2.668 5.96 5.96s-2.668 5.96-5.96 5.96c-0.057 0-0.114-0.001-0.171-0.002l0.008 0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10.809 22.813l-8.782-8.849 8.782-8.853 1.2 1.191-7.6 7.662 7.6 7.658-1.2 1.191z"
  }));
}, "FreeReturnSvg");
var FreeReturnIcon = /* @__PURE__ */ __name(function FreeReturnIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: FreeReturnSvg
  }, props));
}, "FreeReturnIcon");
export {
  FreeReturnIcon
};
